import React, { useEffect, useState } from "react";
import { Route, Redirect, Link, useLocation } from "react-router-dom";
import { Avatar, Breadcrumb, Image } from "antd";
import cookie from "react-cookies";
import "./index.less";
import { DownOutlined } from "@ant-design/icons";
import utils from "../../assets/js/public";

const ContBreadcrumb = (props) => {
  const { basicRouters } = props;
  const { pathname } = useLocation();
  const [breadcrumbList, setBreadcrumbList] = useState([]);
  useEffect(() => {
    // console.log(props);
    // console.log(basicRouters);
    // console.log(pathname);
    if (basicRouters && basicRouters.length) {
      let resRouter = utils.getParents(
        basicRouters,
        pathname,
        "path",
        "children"
      );
      if (resRouter) {
        resRouter = resRouter.sort((a, b) => a.key - b.key);
      }
      setBreadcrumbList(resRouter);
    }
  }, [basicRouters, pathname]);
  return (
    <div className="cont-breadcrumb">
      <div className="breadcrumb">
        <Breadcrumb separator="&gt;">
          {breadcrumbList &&
            breadcrumbList.length &&
            breadcrumbList.map((e, i) => {
              if (i !== breadcrumbList.length - 1) {
                return (
                  <Breadcrumb.Item key={i}>
                    <Link to={e.path} style={{ color: "#333" }}>
                      {e.title}
                    </Link>
                  </Breadcrumb.Item>
                );
              } else {
                return (
                  <Breadcrumb.Item key={i}>
                    <Link to={e.path}>{e.title}</Link>
                  </Breadcrumb.Item>
                );
              }
            })}
        </Breadcrumb>
      </div>
    </div>
  );
};

export default ContBreadcrumb;
